module.exports = __webpack_public_path__ + "static/img/tiexian-btn.b63e70e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/platformIntroduce/tiexian-btn.png
// module id = zC5w
// module chunks = 70